// extracted by mini-css-extract-plugin
module.exports = {"formItem":"ReportCustomerBirthday_formItem__1sO9n"};